require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.4@core-js/library/modules/es7.symbol.async-iterator.js
// module id = /0Fm
// module chunks = 0